var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useEffect } from 'react';
import { nl2br, targetBlankifyLinks } from '../../../lib/helpers';
import { ErrorMsg } from '../../error-msg';
import { useGetComputedDirection } from '../../../hooks/use-get-computed-direction';
export var TextareaField = function (_a) {
    var data = _a.data, value = _a.value, inputValueChange = _a.inputValueChange, blurHandler = _a.blurHandler;
    var inputRef = useRef();
    useEffect(function () {
        inputRef.current.value = value.value;
    }, []);
    var _b = useGetComputedDirection(data.placeholder, value.value), dir = _b[0], hiddenElements = _b[1];
    var onChange = function (e) {
        var _a = e.target, selectionStart = _a.selectionStart, selectionEnd = _a.selectionEnd;
        inputValueChange(data.qid, 'textInput', e.target.value);
        e.target.setSelectionRange(selectionStart, selectionEnd);
    };
    var onBlur = function () {
        blurHandler(data.qid);
    };
    var labelHtml = {
        __html: nl2br(targetBlankifyLinks(data.label)),
    };
    return (_jsxs("div", __assign({ className: data.className ? data.className : 'col-xs-12' }, { children: [hiddenElements, _jsxs("div", __assign({ className: "input-line input-textfield" }, { children: [data.label && (_jsxs("label", __assign({ htmlFor: data.qid, dir: "auto" }, { children: [_jsx("span", { dangerouslySetInnerHTML: labelHtml }, void 0), _jsx("span", __assign({ className: "fieldRequired" }, { children: data.required && '*' }), void 0)] }), void 0)), _jsx("textarea", { dir: dir, ref: inputRef, id: data.qid, name: data.qid, className: data.errorMessage
                            ? 'form-control input-error-border'
                            : 'form-control', cols: 42, rows: +data.rows, placeholder: data.placeholder, onChange: onChange, onBlur: onBlur, "aria-required": data.required, "aria-invalid": !!data.errorMessage }, void 0), data.errorMessage && (_jsx(ErrorMsg, { id: data.qid, error: data.errorMessage }, void 0))] }), void 0)] }), data.qid));
};
